import React, { useState, useEffect } from 'react';
import './ProjectManagement.css';
import { fetchProjects, createProject, deleteProject } from '../services/api';

const ProjectManagement = () => {
  const [projects, setProjects] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    kb_id: '',
    status: 'active'
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    try {
      setLoading(true);
      const result = await fetchProjects();
      
      if (result.success) {
        setProjects(result.projects);
      } else {
        setError(result.error || '프로젝트 목록을 불러올 수 없습니다');
      }
    } catch (error) {
      console.error('프로젝트 목록 로드 실패:', error);
      setError('프로젝트 목록을 불러올 수 없습니다');
    } finally {
      setLoading(false);
    }
  };

  const handleAddProject = async () => {
    if (!formData.id || !formData.kb_id) {
      setError('ID와 KB_ID를 입력해주세요');
      return;
    }

    try {
      setLoading(true);
      const result = await createProject(formData);
      
      if (result.success) {
        setShowAddModal(false);
        setFormData({ id: '', kb_id: '', status: 'active' });
        setError(null);
        await loadProjects();
      } else {
        setError(result.error || '프로젝트 등록에 실패했습니다');
      }
    } catch (error) {
      console.error('프로젝트 등록 실패:', error);
      setError('프로젝트 등록에 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteProject = async (projectPk) => {
    if (!window.confirm('정말로 이 프로젝트를 삭제하시겠습니까?')) {
      return;
    }

    try {
      setLoading(true);
      const result = await deleteProject(projectPk);
      
      if (result.success) {
        await loadProjects();
      } else {
        setError(result.error || '프로젝트 삭제에 실패했습니다');
      }
    } catch (error) {
      console.error('프로젝트 삭제 실패:', error);
      setError('프로젝트 삭제에 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="project-management">
      <div className="project-header">
        <h4>프로젝트 관리</h4>
        <button 
          className="btn btn-primary"
          onClick={() => setShowAddModal(true)}
          disabled={loading}
        >
          + 프로젝트 추가
        </button>
      </div>

      {error && (
        <div className="error-message">
          {error}
          <button onClick={() => setError(null)}>×</button>
        </div>
      )}

      {loading && <div className="loading">로딩 중...</div>}

      <div className="projects-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>KB_ID</th>
              <th>상태</th>
              <th>작업</th>
            </tr>
          </thead>
          <tbody>
            {projects.length === 0 ? (
              <tr>
                <td colSpan="4" className="empty-state">
                  등록된 프로젝트가 없습니다
                </td>
              </tr>
            ) : (
              projects.map((project) => (
                <tr key={project.pk}>
                  <td><code>{project.id}</code></td>
                  <td><code>{project.kb_id}</code></td>
                  <td>
                    <span className={`status ${project.status}`}>
                      {project.status === 'active' ? '활성' : '비활성'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button 
                        className="btn-icon btn-delete"
                        onClick={() => handleDeleteProject(project.pk)}
                        title="프로젝트 삭제"
                        disabled={loading}
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* 프로젝트 추가 모달 */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>새 프로젝트 추가</h3>
            
            <div className="form-group">
              <label>ID *</label>
              <input
                type="text"
                value={formData.id}
                onChange={(e) => setFormData({...formData, id: e.target.value})}
                placeholder="예: skt-bss"
              />
            </div>

            <div className="form-group">
              <label>KB_ID *</label>
              <input
                type="text"
                value={formData.kb_id}
                onChange={(e) => setFormData({...formData, kb_id: e.target.value})}
                placeholder="예: 6LKGBWMERS"
              />
            </div>

            <div className="form-group">
              <label>상태</label>
              <select
                value={formData.status}
                onChange={(e) => setFormData({...formData, status: e.target.value})}
              >
                <option value="active">활성</option>
                <option value="inactive">비활성</option>
              </select>
            </div>

            <div className="modal-actions">
              <button 
                className="btn btn-cancel"
                onClick={() => {
                  setShowAddModal(false);
                  setFormData({ id: '', kb_id: '', status: 'active' });
                  setError(null);
                }}
              >
                취소
              </button>
              <button 
                className="btn btn-confirm"
                onClick={handleAddProject}
                disabled={loading}
              >
                추가
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectManagement;